module.exports = __webpack_public_path__ + "static/media/fedpa-headset.2d9a8ddc.svg";